import UserLineIcon from "remixicon-react/UserLineIcon";
import { InfoContainer, Text } from "$components";
import EditButton from "../components/EditButton";
import { useStyles } from "../styles";
import { ProjectDetailsLogic } from "../types";

type ProjectContactInfoProps = Pick<
  ProjectDetailsLogic,
  | "project"
  | "canEdit"
  | "isProjectDisabled"
  | "handleEditProject"
  | "isAlias"
  | "cleanEmail"
  | "email"
  | "fullname"
>;

export default function ProjectContactInfo({
  project,
  canEdit,
  isProjectDisabled,
  handleEditProject,
  isAlias,
  cleanEmail,
  email,
  fullname,
}: ProjectContactInfoProps) {
  const clasx = useStyles();

  return (
    <InfoContainer
      className={[clasx.projectInformationHeader, clasx.infoHeight].join(" ")}
      leftHeader={
        <div className={clasx.infoHeader}>
          <UserLineIcon />
          <Text type="h3">Informations contact</Text>
        </div>
      }
      rightHeader={
        <EditButton
          onClick={handleEditProject}
          canEdit={canEdit}
          isProjectDisabled={isProjectDisabled}
        />
      }
    >
      <div className="about">
        <div className="left">
          <table>
            <tr>
              <td className="label">Entreprise</td>
              <td className="data">{(project?.company as any)?.name}</td>
            </tr>
            <tr>
              <td className="label">Contact</td>
              <td className={`data ${isAlias ? "disable" : ""}`}>{fullname}</td>
            </tr>
            <tr>
              <td className="label">Email</td>
              <td className={`data ${isAlias ? "disable" : ""}`}>
                {cleanEmail || (email ?? "N/A")}
              </td>
            </tr>
            {(project?.contact as any)?.phone && (
              <tr>
                <td className="label">Téléphone</td>
                <td className={`data ${isAlias ? "disable" : ""}`}>
                  {(project?.contact as any)?.phone}
                </td>
              </tr>
            )}
          </table>
        </div>
      </div>
    </InfoContainer>
  );
}
